/**
 * @file        src/components/Aurora.jsx
 * @description Ambient gradient backdrop. Pure decoration.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */
export default function Aurora() {
  return (
    <div className="aurora" aria-hidden>
      <span className="blob b1" />
      <span className="blob b2" />
      <span className="blob b3" />
      <span className="grain" />
    </div>
  );
}
